(() => {
  function switchTab(root, index) {
    const tabs = root.querySelectorAll('.tabbed-drive-kit__tab');
    const panels = root.querySelectorAll('.tabbed-drive-kit__panel');

    tabs.forEach((tab, i) => {
      const isActive = i === index;
      tab.classList.toggle('active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach((panel, i) => {
      panel.classList.toggle('active', i === index);
    });
  }

  function init(root) {
    if (!root || root.dataset.tabbedDriveKitInit === 'true') return;

    const tabs = root.querySelectorAll('.tabbed-drive-kit__tab');
    const panels = root.querySelectorAll('.tabbed-drive-kit__panel');

    if (panels.length === 0) return;

    panels.forEach((panel, index) => {
      panel.classList.toggle('active', index === 0);
    });

    root.classList.add('tabbed-drive-kit--initialized');

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => switchTab(root, index));

      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextIndex = (index + direction + tabs.length) % tabs.length;
        tabs[nextIndex].focus();
        switchTab(root, nextIndex);
      });
    });

    root.dataset.tabbedDriveKitInit = 'true';
  }

  function initAll() {
    document.querySelectorAll('.tabbed-drive-kit').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('.tabbed-drive-kit');
    if (root) {
      delete root.dataset.tabbedDriveKitInit;
      init(root);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('.tabbed-drive-kit');
    if (root) {
      delete root.dataset.tabbedDriveKitInit;
    }
  });
})();
